<div [ngClass]="cssClass" *transloco="let t; read: 'ime.common.specs'">
  <label *ngIf="showLabel">{{t('Specs')}}</label>
  <ng-container *ngFor="let spec of specs | orderBy: 'Sequence'">
    <ng-container *ngLet="(propertiesQuery.selectEntity(spec.PropertyId) | async) as property">
      <div class="d-flex justify-content-between pb-1" *ngIf="(propertyGroups.length > 0 && spec.PropertyId) ? propertyGroups.indexOf(property?.GroupClv) > -1 : true">
        <div class="w-50 me-1">
          <mes-web-property-select name="property-{{spec.Id}}" [items$]="propertiesQuery.selectAll$" [entityId]="spec.PropertyId" [clearable]="true" [initOpened]="false" [propertyGroups]="propertyGroups"
                                   (entityIdChange)="spec.PropertyId = $event; spec.resetValue(); onLineChanged.emit(spec)"/>
        </div>
        <div class="w-50">
          <ng-container *ngIf="!hasSpecFilterOptions || specFilterOptions.MatchMode === FilterMatchMode.EQUALS || specFilterOptions.MatchMode === FilterMatchMode.NOT_EQUALS">
            <ng-container [ngSwitch]="isMultiChoice && property?.TypeClv === Classificators.PropertyType.Choice">
              <ng-container *ngSwitchCase="true">
                <mes-web-classificator-value-select name="multichoice-{{spec.Id}}"
                                                    [items]="classificatorValuesQuery.getAll$ | async | where: 'ClassificatorId': property?.ChoiceTypeClassificatorId"
                                                    [entityIds]="spec.ValueClvs" [classificatorId]="property?.ChoiceTypeClassificatorId" [multiple]="true"
                                                    (entityIdsChange)="spec.ValueClvs = $event; onLineChanged.emit(spec); onValueChanged.emit(spec)"/>
              </ng-container>
              <ng-container *ngSwitchCase="false">
                <web-spec-value [spec]="spec" (changed)="onLineChanged.emit(spec); onValueChanged.emit(spec)" (edit)="edit.emit($event)"/>
              </ng-container>
            </ng-container>
          </ng-container>
          <input *ngIf="hasSpecFilterOptions && specFilterOptions.MatchMode === FilterMatchMode.CONTAINS && spec.PropertyId" type="search" name="text-{{spec.Id}}" class="form-control form-control-sm" [(ngModel)]="spec.Value"
                 (change)="onLineChanged.emit(spec); onValueChanged.emit(spec)" (search)="onLineChanged.emit(spec); onValueChanged.emit(spec)">
        </div>
        <div *ngIf="showRemove">
          <button class="btn btn-danger btn-sm ms-1" (click)="onLineRemoved.emit(spec)" type="button">
            <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#trash"></svg>
          </button>
        </div>
      </div>
    </ng-container>
  </ng-container>
  <div class="d-flex justify-content-end">
    <ng-container *ngIf="hasSpecFilterOptions">
      <div class="me-1">
        <input type="radio" id="equals" name="equals" [checked]="specFilterOptions.MatchMode === FilterMatchMode.EQUALS" (change)="setMatchMode(FilterMatchMode.EQUALS)">
        <label class="mx-1" for="equals">{{t('Equals')}}</label>
      </div>
      <div class="me-1">
        <input type="radio" id="notEquals" name="notEquals" [checked]="specFilterOptions.MatchMode === FilterMatchMode.NOT_EQUALS" (change)="setMatchMode(FilterMatchMode.NOT_EQUALS)">
        <label class="mx-1" for="notEquals">{{t('Not Equals')}}</label>
      </div>
      <div class="me-1">
        <input type="radio" id="contains" name="contains" [checked]="specFilterOptions.MatchMode === FilterMatchMode.CONTAINS" (change)="setMatchMode(FilterMatchMode.CONTAINS)">
        <label class="mx-1" for="contains">{{t('Contains')}}</label>
      </div>
    </ng-container>
    <button type="button" class="btn btn-sm btn-outline-primary" *ngIf="showAdd" (click)="addSpec()">
      <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#plus"></svg>
      {{t('Add')}}
    </button>
  </div>
</div>
